import useScript from "@hooks/useScript/useScript";

export default function useCasScript() {
  const CAS_SCRIPT = import.meta.env.VITE_CDP_SCRIPT as string;

  const { isScriptReady } = useScript({
    id: "cas-script",
    src: CAS_SCRIPT,
    checkScriptIsLoaded: () => {
      return (
        typeof window.SPH_CDP === "function" &&
        typeof window._data !== "undefined"
      );
    },
  });

  return { isScriptReady };
}
